import styled, { css } from 'styled-components';
import { COLORS } from '~/src/styles/tokens/colors';
import { rem } from '~/src/helpers/rem-converter.helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_767 } from '~/src/styles/tokens/break-points';

export const LegalInfoWrapper = styled.div`
    width: 100%;
    height: fit-content;
    border-radius: ${BORDER_RADIUS.normal8};
    padding: ${rem(10)} ${rem(20)};
    border: 1px solid ${COLORS.backgroundLightStroke};
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: ${rem(12)} 0;
            flex-direction: column-reverse;
        `,
    )};
`;

export const CompanySuggestionWrapper = styled.div`
    width: 90%;
`;

export const ImageWrapper = styled.div`
    position: relative;
    z-index: ${Z_INDEX.level1};
    width: ${rem(24)};
    height: ${rem(24)};
    display: flex;
    justify-content: center;
    align-items: center;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            align-self: end;
            margin-right: ${rem(12)};
        `,
    )};
`;
